<template>
  <div>
    <div class="physio-warp" v-for="(recipeItem, recipeIndex) in chineseMedicineItem" :key="recipeIndex">
      <div class="physio-top backfff" :class="{ 'disabled': isDisabled }">
        <div class="top-left">
          <img :src="imgArr.chineseMedicineIcon" class="physio-icon">
          <div class="physio-title">中成药处方 {{ recipeIndex + 1 }}</div>
          <div>总价￥{{ $toFixed(recipeItem.totalPrice) }}</div>
        </div>
        <div class="top-right">
          <div class="top-right">
            <el-button size="medium" class="process" @click="printerPrescription(recipeItem)">打印</el-button>
          </div>
          <div class="del pointer" v-if="!isDisabled">
            <i class="iconfont icon-shanch" @click="removePhysio(recipeIndex, recipeItem.orderCaseProjectRecipeId)"></i>
          </div>

        </div>
      </div>
      <div class="physio-content backfff" :class="{ 'disabled': isDisabled }">
        <div class="add-warp" v-for="(item, index) in recipeItem.items" :key="index">
          <div class="add-warp-item">
            <div class="index">
              <i class="el-icon-plus" v-if="index == recipeItem.items.length - 1"></i>
              <span v-else>{{ index + 1 }}</span>
            </div>
            <div class="select-warp">
              <el-tooltip v-if="item.inventory != null && item.itemNum > item.inventory && item.onSale == '1'"
                class="item" effect="dark" content="库存不足" placement="top">
                <span class="iconfont icon-jingg colorFE8F ml8"></span>
              </el-tooltip>
              <el-tooltip v-if="item.onSale == '0'" class="item" effect="dark" content="药品已停售" placement="top">
                <span class="iconfont icon-tinshou colorF54A ml8"></span>
              </el-tooltip>
              <el-select :disabled="isDisabled" :ref="'itemName' + recipeIndex + index" v-model="item.itemName"
                placeholder=" 输入药名或拼音码" remote filterable :remote-method="remoteMethod"
                @change="selectChineseMedicine($event, recipeIndex, index)" :loading="loading"
                :popper-append-to-body="false" popper-class="customSelectStyle">
                <el-option disabled value="1" style="pointer-events:none;background:#F0F1F3;">
                  <span style="width:200px; display:inline-block">项目名称</span>
                  <span style="width: 104px; display:inline-block">规格</span>
                  <span style="width: 104px; display:inline-block">类型</span>
                  <span style="width: 100px; display:inline-block">库存</span>
                  <span style="width: 64px; display:inline-block">单位</span>
                  <span style="width: 80px; display:inline-block">价格</span>
                  <span style="width: 70px; display:inline-block">医保属性</span>
                  <span style="width: 80px; display:inline-block">spuId</span>
                </el-option>
                <el-option v-for="(obj, index1) in otherOptions" :key="index1" :label="obj.itemName"
                  :value="obj.itemId">
                  <span style="width:200px; display:inline-block">{{ obj.itemName }}</span>
                  <span style="width: 104px; display:inline-block">{{ obj.spec || '-' }}</span>
                  <span style="width: 104px; display:inline-block">{{ obj.type ? obj.type : '-' }}</span>
                  <span style="width: 100px; display:inline-block">{{ obj.inventory ? obj.inventory : '-' }}</span>
                  <span style="width: 64px; display:inline-block">{{ obj.itemUnit ? obj.itemUnit : '-' }}</span>
                  <span style="width: 80px; display:inline-block">{{ obj.price }}</span>
                  <span style="width:70px; display:inline-block">{{
                    obj.medicalInsuranceType ? computedDictText(obj.medicalInsuranceType, ybPropertyList)
                      : '-'
                  }}</span>
                  <span style="width: 80px; display:inline-block">{{ obj.spuId }}</span>
                </el-option>
              </el-select>
            </div>
            <div class="add-right" v-if="index != recipeItem.items.length - 1">
              <div class="edit-warp">
                <span class="ml5">￥</span>
                <span>{{ item.price }}</span>
              </div>
              <div class="edit-warp" style="text-align: center; width: 30px">
                <div class="w100_">x</div>
              </div>
              <div class="edit-warp" style="width: 50px">
                <el-input type="text" :disabled="isDisabled" :ref="'itemNum' + recipeIndex + index"
                  v-model="item.itemNum" maxlength="6" @input="formatNum($event, recipeItem, item)"
                  @keydown.enter.native="searchMove(recipeIndex, index)"
                  @keydown.down.native.prevent="numberInputMove($event, 'down', index)"
                  @keydown.up.native.prevent="numberInputMove($event, 'up', index)"
                  style="text-align: center"></el-input>
              </div>
              <div class="edit-warp" style="text-align: center; width: 30px">
                <div class="w100_">{{ item.itemUnit }}</div>
              </div>
              <div class="edit-warp">
                <span class="ml5">￥</span>
                {{ $bigNumber(item.price, '*', item.itemNum, 2) }}
              </div>
              <div class="edit-warp">
                <el-input type="text" :disabled="isDisabled" v-model="item.remark" placeholder="备注" maxlength="50"
                  style="width: 90px" @change="handleChineseMedicine(recipeItem)"></el-input>
              </div>
              <div v-if="!isDisabled" class="edit-warp" style="text-align: center; width: 40px">
                <div class="w100_" @click="removeChinsesMedicine(recipeIndex, index)"><i class="el-icon-close"
                    style="font-size: 16px;"></i></div>
              </div>
            </div>
          </div>
          <div class="add-warp-bottom" v-if="item.itemName">
            <div class="method-warp">
              <SelectPanel v-model="item.useFrequency" :options="dictData.useFrequency" width="60px" placeholder="用法"
                valueKey="dictCode" labelKey="dictLabel" :disabled="isDisabled" readonly
                @input="handleChineseMedicine(recipeItem)"></SelectPanel>
              <div class="singleDose-warp">
                <div class="pb3 flex-sh">1次</div>
                <el-input class="singleDose-input" :disabled="isDisabled" maxlength="3" type="text"
                  v-model="item.singleDose" @input="singleDoseChange(recipeItem, item)"
                  style=" width: 40px;"></el-input>
                <SelectPanel v-model="item.singleDoseUnit" :options="dictData.singleDoseUnit" width="50px"
                  placeholder="单位" :caretShow="true" valueKey="dictCode" labelKey="dictLabel" :disabled="isDisabled"
                  readonly @input="handleChineseMedicine(recipeItem)"></SelectPanel>
              </div>

              <SelectPanel class="ml8" v-model="item.takingTime" :options="dictData.takingTime" width="80px"
                placeholder="服用时间" valueKey="dictCode" labelKey="dictLabel" :disabled="isDisabled" readonly
                @input="handleChineseMedicine(recipeItem)"></SelectPanel>
              <SelectPanel class="ml8" v-model="item.intervalRequirement" :options="dictData.intervalRequirement"
                width="130px" valueKey="dictCode" labelKey="dictLabel" placeholder="时间间隔要求" :disabled="isDisabled"
                :itemWidth="160" readonly @input="handleChineseMedicine(recipeItem)"></SelectPanel>
              <el-button type="text" :disabled="isDisabled" @click="openDefaultConfig(recipeIndex, item)">默认用法配置</el-button>
            </div>

          </div>
        </div>
      </div>
    </div>
    <defaultUsageConfigDialog ref="defaultUsageConfigDialog" :dictData="dictData">
    </defaultUsageConfigDialog>
  </div>
</template>

<script>
import { Outpatient } from "../data/index.js";
import { Utils } from "@/utils/utils";
import { ybCenterDrugDirectoryCategorySignList, ybPropertyList } from '@/utils/const';
import { imgArr } from "@/assets/images/img.js";
import { deepClone, isNull, msgboxWarning, isEmptyArray, dictText } from '@/utils/validateBase';
import SelectPanel from '@/components/SelectPanel.vue'
import { getDict } from '@/api/common'
import { getOftenDecoction } from '@/api/outpatientDetail'
import defaultUsageConfigDialog from "../component/defaultUsageConfigDialog.vue";
export default {
  components: { SelectPanel, defaultUsageConfigDialog },
  props: {
    // 非处方项目
    consultationType: String | Number,
    chineseMedicineItem: Array,
    isDisabled: Boolean,
    isEdit: Boolean,
  },
  data() {
    return {
      imgArr: imgArr,
      otherOptions: [],
      loading: false,
      ybCenterDrugDirectoryCategorySignList: ybCenterDrugDirectoryCategorySignList,
      ybPropertyList: ybPropertyList,
      dictData: {
        useFrequency: [],
        singleDoseUnit: [],
        takingTime: [],
        intervalRequirement: [],
      }
    };
  },
  created() {
    this.handleProps()
    this.getDictData()
  },
  watch: {
    chineseMedicineItem(newV, old) {
      this.handleProps()
    },
  },
  computed: {
    computedDictText() {
      return function (value, list) {
        return dictText(value, list)
      }
    },
  },
  methods: {
    //计算价格
    handleProps() {
      this.chineseMedicineItem.forEach(val => {
        this.computeOtherPrice(val, 1)
      })
    },
    /**
   * 输入药品用量
   */
    formatNum: _.debounce(function (e, item, kid) {
      let temp = e.toString();
      temp = temp.replace(/。/g, ".");
      temp = temp.replace(/[^\d.]/g, ""); //清除"数字"和"."以外的字符
      temp = temp.replace(/^\./g, ""); //验证第一个字符是数字
      temp = temp.replace(/\.{2,}/g, ""); //只保留第一个, 清除多余的
      temp = temp.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
      temp = temp.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); //只能输入两个小数
      kid.itemNum = Number(temp);
      this.computeOtherPrice(item)
    }, 500),
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        this.getChineseMedicineOptions(query);
      } else {
        this.options = [];
      }
    },
    getChineseMedicineOptions: _.debounce(function (query) {
      Outpatient.getOtherProject({
        searchWord: query, types: ['3'],
        deptId: this.consultationType === 2 ? process.env.VUE_APP_CHAT_DEPT_ID : this.$session.get('deptId'),
        recipeType: 4
      }).then((res) => {
        this.loading = false;
        this.otherOptions = res;
      });
    }, 500),
    //选择非处方项目
    async selectChineseMedicine(val, recipeIndex, index) {
      let chineseMedicineItem = _.cloneDeep(this.chineseMedicineItem);
      let items = chineseMedicineItem[recipeIndex].items;
      let findArr = items.filter((item) => {
        return item.itemId == val;
      });
      if (!_.isEmpty(findArr)) {
        this.$message.error("不可以重复添加");
        items = chineseMedicineItem[recipeIndex].items[index].itemId = ''
        items = chineseMedicineItem[recipeIndex].items[index].itemName = ''

        this.$emit("updataChineseMedicineItem", chineseMedicineItem);
        return;
      }
      let obj = chineseMedicineItem[recipeIndex].items[index];
      let length = items.length;
      let {code,data} = await getOftenDecoction({spuId: val})
      this.otherOptions.forEach((item) => {
        if (item.itemId == val) {
          obj = { ...obj, ...item };
          obj.itemNum = 1;
          obj.onSale = '1'
          if (code === 200 && data) {
            obj.useFrequency = data.useFrequency
            obj.singleDose = data.singleDose
            obj.singleDoseUnit = data.singleDoseUnit
            obj.takingTime = data.takingTime
            obj.intervalRequirement = data.intervalRequirement
          }else{
            obj.useFrequency = '106'
            obj.singleDose = null
            obj.singleDoseUnit = ''
            obj.takingTime = '117'
            obj.intervalRequirement = ''
          }
        }
      });
      chineseMedicineItem[recipeIndex].items[index] = obj;
      if (length == 1 || index == length - 1) {
        this.addSearch(items);
      }
      this.otherOptions = [];
      this.chineseMedicineItem = chineseMedicineItem
      this.computeOtherPrice(chineseMedicineItem[recipeIndex]);
      this.$nextTick(() => {
        this.$refs[`itemNum${recipeIndex}${index}`][0].focus()
        this.$refs[`itemNum${recipeIndex}${index}`][0].select()
      })
      this.$emit("updataChineseMedicineItem", chineseMedicineItem);
    },
    addSearch(list) {
      list.push({
        itemId: "",
        itemName: "",
        useFrequency: "",
        singleDoseUnit: "",
        takingTime: "",
        intervalRequirement: "",
      });
    },
    computeOtherPrice(item, num) {
      let totalPrice = 0
      item.items.forEach((val) => {
        val.totalPrice = this.$bigNumber(val.price, "*", val.itemNum);
        totalPrice = this.$bigNumber(totalPrice, '+', val.totalPrice);
        val.deleteShow = false
      });
      item.totalPrice = totalPrice
      this.$forceUpdate()
      if (num) return;
      this.handleChineseMedicine(item);
    },
    //删除
    removeChinsesMedicine(recipeIndex, index) {
      let chineseMedicineItem = _.cloneDeep(this.chineseMedicineItem)
      chineseMedicineItem[recipeIndex].items.splice(index, 1);
      this.chineseMedicineItem = chineseMedicineItem
      this.computeOtherPrice(chineseMedicineItem[recipeIndex]);
      this.$emit("updataChineseMedicineItem", chineseMedicineItem);
    },
    //保存非处方项目
    handleChineseMedicine(item) {
      if (this.isDisabled || this.isEdit) return;
      let obj = _.cloneDeep(item);
      obj.items = obj.items.filter((val) => val.itemId != "");
      Outpatient.editPrescription(obj).then((res) => {
        if (!item.orderCaseProjectRecipeId) {
          item.orderCaseProjectRecipeId = res.data;
        }
      });
    },
    searchMove(recipeIndex, index) {
      this.$nextTick(() => {
        this.$refs[`itemName${recipeIndex}${index + 1}`][0].focus()
      })
    },
    numberInputMove(e, type, index) {

      switch (type) {
        case 'up':
          if (Utils.gt(index, 0)) {
            index--;
          }
          this.$refs[`itemNum${index}`][0].focus()
          this.$refs[`itemNum${index}`][0].select()
          break;
        case 'down':
          if (Utils.gt(this.chineseMedicineItem.items.length - 2, index)) {
            index++;
          }
          this.$refs[`itemNum${index}`][0].focus()
          this.$refs[`itemNum${index}`][0].select()
          break;
      }
    },
    /**
     * 删除理疗处方
     */
    removePhysio(index, id) {
      msgboxWarning(this, {
        message: `是否确定删除该处方？`,
        confirmFn: () => {
          let chineseMedicineItem = deepClone(this.chineseMedicineItem)
          if (!isNull(id)) {
            Outpatient.removePrescription({ orderCaseProjectRecipeId: id }).then(res => {
              if (res.code == 200) {
                chineseMedicineItem.splice(index, 1)
                // index = index - 1;
                // if (Utils.gt(physioItem.length, 0)) {
                //     this.computePhysioPrice(physioItem[index]);
                // }
                this.$forceUpdate()
                this.$emit('updataChineseMedicineItem', chineseMedicineItem)
              }
            })
          } else {
            chineseMedicineItem.splice(index, 1)
            // index = index - 1;
            // if (Utils.gt(physioItem.length, 0)) {
            //     this.computePhysioPrice(physioItem[index]);
            // }
            this.$emit('updataChineseMedicineItem', chineseMedicineItem)
          }
        },
        cancelFn: () => {
        },
      });
    },
    //打印处方
    printerPrescription(item) {
      if (_.isEmpty(item.items)) return;
      this.$emit('handlePrint', item)
    },
    //获取字典值
    getDictData() {
      getDict('useFrequency').then(res => {
        if (res.code == 200) {
          this.dictData.useFrequency = res.data
        }
      })
      getDict('singleDoseUnit').then(res => {
        if (res.code == 200) {
          this.dictData.singleDoseUnit = res.data
        }
      })
      getDict('takingTime').then(res => {
        if (res.code == 200) {
          this.dictData.takingTime = res.data
        }
      })
      getDict('intervalRequirement').then(res => {
        if (res.code == 200) {
          this.dictData.intervalRequirement = res.data
        }
      })
    },
    //单次剂量改变
    singleDoseChange(recipeItem, item) {
      if (!item.singleDose) {
        item.singleDose = null
      }
      item.singleDose = String(item.singleDose || '').replace(/[^\d.]/g, '').replace(/\.(\d).*/, '.$1').replace(/^0+([1-9])/, '$1').replace(/^0(\.\d)?$/, '');
      if (!item.singleDose || parseFloat(item.singleDose) <= 0) {
        item.singleDose = '';
      }
      this.handleChineseMedicine(recipeItem)
    },
    //默认用法配置
    async openDefaultConfig(recipeIndex, item) {
      let initData = {
        recipeIndex: recipeIndex,
        spuId: item.spuId,
        useFrequency: '', //用药频次
        singleDose: '',// 单次用量
        singleDoseUnit: '',// 单次用量单位
        takingTime: '',//服用时间
        intervalRequirement: '',//时间间隔要求
      }
      let { code, data } = await getOftenDecoction({ spuId: item.spuId })
      if (code == 200 && data) {
        initData.useFrequency = data.useFrequency
        initData.singleDose = data.singleDose
        initData.singleDoseUnit = data.singleDoseUnit
        initData.takingTime = data.takingTime
        initData.intervalRequirement = data.intervalRequirement
      }
      this.$refs.defaultUsageConfigDialog.open(initData)
    },
  },
};
</script>

<style lang="less" scoped>
@borderColor: #E0E0E0;
@fontColor: #1890FF;

.physio-warp {
  border: 1px solid #EAEAEA;
  box-sizing: border-box;
  margin-bottom: 20px;
  border-radius: 0 0 4px 4px;
  background: #fff;

  // overflow: hidden;
  .physio-top {
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 12px;
    padding-right: 12px;
    box-sizing: border-box;
    border-bottom: 1px solid @borderColor;

    .top-left {
      display: flex;
      align-items: center;
      color: #333;
      font-size: 14px;

      .physio-icon {
        width: 24px;
        height: 24px;
        flex-shrink: 0;
        flex-grow: 0;
        margin-right: 10px;
      }

      .physio-title {
        color: #000;
        font-size: 14px;
        font-weight: 600;
        margin-right: 34px;
      }
    }

    .top-right {
      // width: 26px;
      display: flex;
      font-size: 14px;
      color: #666;

      .del {
        width: 26px;
        height: 26px;
        background: #FFFFFF;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid @borderColor;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 12px;

        .del-icon {
          width: 18px;
          height: 18px;
          cursor: pointer;
        }

        &:hover {
          color: #F54A45;
        }
      }

      .process {
        background: #FFFFFF;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #E1E1E1;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        font-size: 14px;
        padding: 4px 10px;


      }
    }
  }

  .physio-content {
    .add-warp:last-child {
      .index {
        border-right: 0;
      }
    }

    .add-warp {
      border-top: 1px dashed @borderColor;

      &:first-child {
        border-top: 0;
      }

      .add-warp-item {
        height: 40px;
        display: flex;
        border-bottom: 1px dashed @borderColor;

        &:last-child {
          border-bottom: 0;
        }

        .index {
          width: 32px;
          border-right: 1px dashed @borderColor;
          box-sizing: border-box;
          flex-grow: 0;
          flex-shrink: 0;
          display: flex;
          align-items: center;
          justify-content: center;

          .el-icon-plus {
            width: 14px;
            height: 14px;
            color: #999;
          }
        }

        .select-warp {
          padding: 14px 0;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;

          /deep/.el-input__inner {
            font-size: 14px;
            font-weight: 600;
            // padding-left: 0;
          }

          /deep/.is-disabled .el-input__inner {
            color: #6c7a8f;
          }

          /deep/.el-select-dropdown__item {
            display: flex;
          }
        }

        .add-right {
          display: flex;
          align-items: center;
          font-size: 14px;
          color: #1F2329;

          .close-item {
            padding: 2px;
            background-color: #F0F1F3;
            border-radius: 50%;
            color: rgb(154, 160, 168);
            font-size: 12px !important;
          }

          .price-warp {
            height: 100%;
            color: #667182;
            font-size: 14px;
            display: flex;
            align-items: center;
            justify-content: center;
            padding-right: 20px;
            flex-grow: 0;
            flex-shrink: 0;
            // line-height: 40px;
          }

          .edit-warp {
            // color: #6c7a8f;
            width: 128px;
            border-left: 1px solid #E1E1E1;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            .item-section {
              color: #667182;
              font-size: 14px;
            }

            .el-input {
              width: 60px;

              /deep/.el-input__inner {
                padding: 0;
                border: none;
                padding-right: 10px;
                text-align: right;
                font-size: 15px;
                color: #1F2329;
              }

            }
          }

        }

        .close-warp {
          width: 40px;
          border-left: 1px dashed #E1E1E1;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;

          .el-icon-close {
            color: #999;
            width: 13px;
            height: 13px;
            font-weight: bold;
          }
        }
      }

      .add-warp-bottom {
        height: 40px;
        display: flex;
        align-items: center;
        padding: 0 12px;

        .method-warp {
          display: flex;

          .singleDose-warp {
            display: flex;
            align-items: center;
            flex-grow: 0;
            flex-shrink: 0;
            font-size: 14px;
            color: #1F2329;
            margin-left: 8px;

            .singleDose-input {
              flex-grow: 0;
              flex-shrink: 0;
              overflow: hidden;
              border-bottom: 1px solid @borderColor;
              height: 28px;

              &:hover {
                border-bottom: 1px solid @fontColor !important;
              }

              /deep/.el-input-number__decrease,
              /deep/.el-input-number__increase {
                display: none;
              }

              /deep/.el-input__inner {
                line-height: 33px;
                border: none;
                color: #000;
                padding: 0;
                text-align: center;
              }
            }
          }
        }

      }

    }

    .el-select {
      font-size: 14px;
      color: #000;
      font-weight: 400;
      width: 100%;

      /deep/.el-input__inner {
        border: none;
        font-size: 14px;
      }

      /deep/.el-input__suffix {
        display: none;
      }
    }
  }

  /deep/.is-disabled {
    .el-input__inner {
      background: #FFFFFF;
    }
  }

  /deep/.el-tag {
    font-size: 14px;
  }

  .disabled {
    // pointer-events:none;
    background: #F7F8F9 !important;
    cursor: not-allowed !important;

    /deep/.el-input.is-disabled .el-input__inner {
      background: #F7F8F9 !important;
      color: #1F2329;
    }

    /deep/.el-textarea.is-disabled .el-textarea__inner {
      background: #F7F8F9 !important;
      color: #1F2329;
    }
  }
}

.remarkInput {
  /deep/.el-input__inner {
    height: 36px;
    background: #fff;
    color: #333;
    border: 1px solid transparent;
    border-top: 1px solid #E1E1E1;
  }

  /deep/.el-input__inner:focus {
    border-color: #409EFF;
  }
}
</style>